import React from 'react';
import './EntryGroup.css';
import EntryBullet from './EntryBullet/EntryBullet';

const EntryGroup = props => {
  const { position, active, data } = props;
  const bullets = data.map(bulletData => (
    <EntryBullet key={bulletData.video} position={position} data={bulletData} />
  ));
  return (
    <div
      className={`entry-group ${active ? 'active' : ''} ${
        position === 1 ? 'top' : 'bottom'
      }`}
    >
      {bullets}
    </div>
  );
};

export default EntryGroup;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/Timeline/TimeEntry/EntryGroup/EntryGroup.js